/**
 * Admin sidebar item definitions.
 *
 * Grouped into three sections:
 * - Activity: read-only history / monitoring pages
 * - Configuration: pages that change pipeline behavior
 * - Operations: bulk tools + reports
 *
 * The sidebar is rendered by `AdminLayout`. Each item routes to a page under
 * `/admin/*`. Legacy `/ops/*` URLs are redirected in App.tsx.
 */

export interface AdminNavItem {
  to: string;
  label: string;
  /**
   * When set, render a non-interactive group label immediately BEFORE this
   * item. Used by `AdminLayout` to cluster related pages in the sidebar.
   */
  groupStart?: string;
  /** bootstrap-icons class name (without the `bi bi-` prefix). */
  icon?: string;
}

export const ADMIN_NAV: AdminNavItem[] = [
  // Activity — read-only history & monitoring
  { to: '/admin/scans', label: 'Channel Scan History', icon: 'broadcast-pin', groupStart: 'Activity' },
  { to: '/admin/raw-posts', label: 'Raw Scraped Posts', icon: 'file-earmark-text' },
  { to: '/admin/venue-identifications', label: 'Venue Identification History', icon: 'geo-alt' },
  { to: '/admin/date-recalculations', label: 'Event Date Recalculation History', icon: 'calendar2-week' },
  { to: '/admin/flagged-for-ai-review', label: 'Flagged for AI Review', icon: 'flag' },

  // Configuration — knobs that change behavior
  { to: '/admin/source-feeds', label: 'Source feeds', icon: 'rss', groupStart: 'Configuration' },
  { to: '/admin/scan-cadence', label: 'Scan cadence', icon: 'clock-history' },
  { to: '/admin/coverage', label: 'Coverage', icon: 'pin-map' },
  { to: '/admin/ai-extraction', label: 'AI extraction', icon: 'cpu' },
  { to: '/admin/secrets', label: 'Secrets', icon: 'shield-lock' },
  { to: '/admin/extension-keys', label: 'Extension keys', icon: 'key' },
  { to: '/admin/settings', label: 'Settings', icon: 'sliders' },
  { to: '/admin/notifications', label: 'Notifications', icon: 'bell' },

  // Operations — tools that act on data in bulk
  { to: '/admin/jobs', label: 'Bulk Jobs', icon: 'lightning-charge', groupStart: 'Operations' },
  { to: '/admin/bulk-recalculate', label: 'Bulk Recalculate Dates', icon: 'calendar2-range' },
  { to: '/admin/reports', label: 'Reports', icon: 'bar-chart' },
];
